<script>
	import Image from '$lib/Components/Layout/Image/Image.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';

	import roomImg from './images/LP-Terms-of-Sale-C-01.jpg';
</script>

<Section backgroundColor="blue" class="pb-0 [&_p]:text-left">
	<p>
		Payment of your balance due on any Indow order confirmation constitutes
		acceptance of the terms outlined here. By confirming your order, you agree
		that the information provided and products selected are accurate.
		Confirmation of inaccurate order information may result in additional fees
		if changes are requested. Upon payment of your final invoice, sent under
		separate cover your inserts will go into production.
	</p>
	<p>
		Return of any Indow property including the measure kit, if applicable, will
		be required prior to shipment of your Indow window inserts and/or accessory
		products. Failure to complete payment of your final invoice within 14 days
		of invoice date may result in the cancellation of your order and a refund of
		any deposit collected less a $50 processing fee. Failure to return a laser
		measure kit, if one was sent to you, will result in the conversion of your
		deposit into a purchase of the laser measure kit for $175.
	</p>
	<p>
		As Indow inserts are custom manufactured to your exact specifications, all
		sales are final. Please be sure to review your needs carefully with your
		Indow representative to ensure that the product and grade you select is the
		most appropriate for your application. You are responsible for the
		assessment of your needs and how light, sound, and other factors affecting
		your comfort enter your home. Indow warrants our products to be properly
		manufactured to your dimensions, but given the uniqueness of your home or
		building no performance guarantees, returns, or exchanges based on
		performance can be made.
	</p>
	<p>
		Indow window inserts are packaged and shipped using the highest standards of
		care. Upon receipt of your order it is your responsibility to promptly
		inspect the product for any shipping damage. In the unlikely event damage is
		discovered, Indow will handle all claimswith the shipper, however all
		packaging must be saved and the Indow claim process must be followed.
		Details on receiving your shipment to best protect both you and Indow, and
		the step by step claim process in the event of damage, is available <a
			href="/claim-submission-customer">here</a
		>.
	</p>
	<p>
		Your Indow window inserts are backed by a best of class limited lifetime
		warranty. Details are available <a
			href="/warranties/residential-lifetime-warranty">here</a
		>.
	</p>
	<p>Sincerely,</p>
	<p>Indow</p>
	<p>Effective – 10/1/2021</p>
	<div class="!col-span-full">
		<Image src={roomImg} class="max-w-full" />
	</div>
</Section>
